// Copyright (c) AdCritter. All rights reserved.

import moment from 'moment'
import { FC } from 'react'

import { EuiSpacer } from '@elastic/eui'

import { AIPlanPreview } from 'api/entities/AIPlanPreview'
import { MasterCampaignPlanCampaignBuilder } from 'api/entities/MasterCampaignStub'

import Budget from 'pages/MasterCampaignPlanPage/new/components/Budget'
import AudienceAndGeoTargeting from 'pages/MasterCampaignPlanPage/new/components/ExecutiveSummary/AudienceAndGeoTargeting'
import CampaignTimeline from 'pages/MasterCampaignPlanPage/new/components/ExecutiveSummary/CampaignTimeline'
import ChannelUtilization from 'pages/MasterCampaignPlanPage/new/components/ExecutiveSummary/ChannelUtilization'
import PlanDescription from 'pages/MasterCampaignPlanPage/new/components/ExecutiveSummary/PlanDescription'
import RenderCustomSections from 'pages/MasterCampaignPlanPage/new/components/RenderCustomSections'
import TabPageHeader from 'pages/MasterCampaignPlanPage/new/components/TabPageHeader'

interface AIPlanExecutiveSummaryProps {
  aiPlan: AIPlanPreview
}

const AIPlanExecutiveSummary: FC<AIPlanExecutiveSummaryProps> = ({ aiPlan }) => {
  const campaigns = (aiPlan.aiPlanStub?.campaignBuilders ?? []) as unknown as MasterCampaignPlanCampaignBuilder[]
  const planStartDate = moment(aiPlan.aiUsedStartDate)
  const planDurationMonths = aiPlan.aiUsedDurationInMonths
  const section = aiPlan.executiveSummarySection

  const pageTitle = section?.pageTitle || 'Executive Summary'

  return (
    <>
      <TabPageHeader title={pageTitle} />

      {section?.introduction?.hideAll !== true && (
        <>
          <PlanDescription accountName={aiPlan.accountName} section={section?.introduction as any} campaigns={campaigns} />
          <EuiSpacer size='xl' />
        </>
      )}

      <RenderCustomSections sections={section?.aboveCampaignTimeline as any} />

      <CampaignTimeline campaigns={campaigns} planStartDate={planStartDate} planDurationMonths={planDurationMonths} isClickable={false} isHoverable={false} />

      <EuiSpacer size='xl' />

      <RenderCustomSections sections={section?.aboveChannelUtilization as any} />

      {section?.channelUtilization?.hideAll !== true && (
        <>
          <ChannelUtilization campaigns={campaigns} section={section?.channelUtilization as any} />
          <EuiSpacer size='xl' />
        </>
      )}

      <RenderCustomSections sections={section?.aboveAudienceAndGeoSummary as any} />

      <AudienceAndGeoTargeting
        masterCampaignPlan={{ audienceSummary: aiPlan.audienceSummary ?? '', geoSummary: aiPlan.geoSummary ?? '' } as any}
        audienceSection={section?.audienceStrategy as any}
        geoSection={section?.geographicTargeting as any}
      />
      <EuiSpacer size='xl' />

      <RenderCustomSections sections={section?.aboveBudget as any} />

      {section?.budget?.hideAll !== true && (
        <>
          <Budget campaigns={campaigns} section={section?.budget as any} />
          <EuiSpacer size='xl' />
        </>
      )}

      <RenderCustomSections sections={section?.aboveBottom as any} />
    </>
  )
}

export default AIPlanExecutiveSummary
